<template>
	<div class="action-flow-node" style="height: 240px;">
		<div class="action-flow-title">Component Message</div>
		<div class="action-flow-hint">Tell a component to do or change an internal setting.</div>
		
		<ActionParamHint label="Message" hint="What type of message should be sent to the component." param-class="param-config"
			param-input-type="select"  param-input-label="Message Type" @param-change="handleParamChange"
			:param-input-options="[{ value: 'source', label: 'Change Data Source' }, { value: 'refresh', label: 'Refresh' }, { value: 'scroll', label: 'Scroll to item' }]"
			:param-input-value="parameters.message"
		/>
		<ActionParamHint label="Component" hint="Select a component to send a message to. Specifying a component will ignore this input." param-class="param-tgt"
			param-input-type="text"  param-input-label="Component" @param-change="handleParamChange"
			:param-input-value="parameters.component"
		/>
		<ActionParamHint label="Argument" hint="Argument to provide in message (mote, text, etc)." param-class="param-tgt" />
		<ActionParamHint label="Message Sent" hint="Flow continues when message is sent and component responds." param-class="param-src" />
		
		<Handle type="target" id="tgt-message" :position="Position.Left" style="top: 135px;" />
		<Handle type="target" id="tgt-argument" :position="Position.Left" style="top: 175px;" />
		<Handle type="source" id="src-sent" :position="Position.Right" style="top: 215px;" />
	</div>
</template>

<script setup>
/* eslint-disable */
import { ref, watch } from 'vue'
import { Handle, Position, useNodesData, useVueFlow } from '@vue-flow/core'
import ActionParamHint from './action-param-hint.vue'

const props = defineProps({
	id: String,
});

// Access the current node's data
const nodeData = useNodesData(() => props.id);
const { updateNode } = useVueFlow()

// Store parameter values
const parameters = ref({
	message: '',
	component: '',
});

// Watch for changes in nodeData and update parameters accordingly
watch(nodeData, (newNodeData) => {
	if (newNodeData) {
		parameters.value = {
			message: newNodeData.data?.message || '',
			component: newNodeData.data?.component || '',
		};
	}
}, { immediate: true });

// Handle parameter changes from ActionParamHint components
const handleParamChange = (paramData) => {
	// Store the parameter value based on the label
	let key = paramData.label.toLowerCase();
	if (!(key in parameters.value)) {
		console.error(`Unknown parameter label: ${paramData.label}`);
		return;
	}
	parameters.value[key] = paramData.value;
	
	// Update the node data in Vue Flow.
	updateNode(props.id, (node) => ({
		data: {
			...node.data,
			...parameters.value
		}
	}));
}

</script>
	